import {
  Injectable
} from '@angular/core';
import { Router } from '@angular/router';
import Utils from './utils';


@Injectable({
  providedIn: 'root'
})

export class UtilsService {

  // incoming Msg elment ID
  incomMsgEL = '#IEIncomMsg';

  // right Container element ID
  rightContainerId = '#right_container_id';

  // Taxonomy Protip element ID
  taxonomyProtip = '#taxonomyProtip';

  // Tab Container id
  tabContainer = '#tabContainer';

  // Tree Detail View id
  treeDetailsView = '#treeDetailsView';

  // add Additional MetadataId id
  addAdditionalMetadataId = 'addAdditionalMetadata';

  //  add Association id
  addAssociationId = 'add-association';

  // add Exemplar id
  addExemplarId = 'add-exemplar';

  // container Fluid Class name
  containerFluidClass = '.container-fluid';

  // File Panel Class name
  filePanelClass = '.file-panel';

  // Modal Body Class name
  modalBodyClass = '.modal-body';

  // Authoring Header class name
  authoringHeader = '.authoring-header';

  // Search Field Input class name
  searchFieldInput = '.search-field input';

  constructor(private router: Router) {}

  /**
   * Set Asset Panel Height for the association and linked nodes plus icon modal
   */
  assetPanelHeight() {
    if (document.getElementById(this.addAssociationId)) {

      const associationfilePanelHeight =
        document.getElementById(this.addAssociationId)
          .querySelector(this.filePanelClass) && document.getElementById(this.addAssociationId)
            .querySelector(this.filePanelClass).children?.length > 0 ?
          document.getElementById(this.addAssociationId)
            .querySelector(this.filePanelClass).children[0].
            clientHeight : 0;

      const associationcontainrHeight =
        document.getElementById(this.addAssociationId)
          .querySelector(this.containerFluidClass) ? document.getElementById(this.addAssociationId)
            .querySelector(this.containerFluidClass)
          .clientHeight : 0;

      let height = 'height:' + associationcontainrHeight + 'px';
      if (associationfilePanelHeight > associationcontainrHeight) {
        height = 'height:' + associationfilePanelHeight + 'px';
      }

      if (document.getElementById(this.addAssociationId).querySelector(this.filePanelClass)) {
        document.getElementById(this.addAssociationId)
          .querySelector(this.filePanelClass).setAttribute('style', height);
      }
    }
  }

  /**
   * Set Exemplar Asset Panel Height
   */
  exemplarAssetPanelHeight() {
    if (document.getElementById(this.addExemplarId)) {

      const filePanelHeight =
        document.getElementById(this.addExemplarId)
          .querySelector(this.filePanelClass) && document.getElementById(this.addExemplarId)
            .querySelector(this.filePanelClass).children?.length > 0 ?
          document.getElementById(this.addExemplarId)
            .querySelector(this.filePanelClass).children[0].
            clientHeight : 0;

      const containrHeight =
        document.getElementById(this.addExemplarId)
          .querySelector(this.containerFluidClass) ? document.getElementById(this.addExemplarId)
            .querySelector(this.containerFluidClass)
          .clientHeight : 0;

      let height = 'height:' + containrHeight + 'px';
      if (filePanelHeight > containrHeight) {
        height = 'height:' + filePanelHeight + 'px';
      }

      if (document.getElementById(this.addExemplarId).querySelector(this.filePanelClass)) {
        document.getElementById(this.addExemplarId)
          .querySelector(this.filePanelClass)
          .setAttribute('style', height);
      }

    }
  }

  /**
   * Set Additional Metadata Panel Height
   */
  additionalMetadataPanelHeight() {
    if (document.getElementById(this.addAdditionalMetadataId)) {
      const modalBodyHeight =
        document.getElementById(this.addAdditionalMetadataId)
          .querySelector(this.modalBodyClass)?.
          clientHeight;

      const containerSiblings =
        document.getElementById(this.addAdditionalMetadataId)
          .querySelector(this.containerFluidClass)?.parentNode?.children;
      const containerSiblingsHeight =
        containerSiblings.length > 0 ?
          containerSiblings[0].clientHeight
          : 0;

      const metadataPanelChildren =
        document.getElementById(this.addAdditionalMetadataId)
          .querySelector(this.filePanelClass)?.children;

      const metadataPanelChildrenHeight =
        metadataPanelChildren.length > 0 ?
          metadataPanelChildren[0].clientHeight
          : 0;

      const newPanelHeight = modalBodyHeight - containerSiblingsHeight;

      if (newPanelHeight > metadataPanelChildrenHeight) {
        const height = 'height:' + newPanelHeight + 'px';
        document.getElementById(this.addAdditionalMetadataId)
          .querySelector(this.filePanelClass)?.setAttribute('style', height);
      } else {
        const height = 'height:' + metadataPanelChildrenHeight + 'px';
        document.getElementById(this.addAdditionalMetadataId)
          .querySelector(this.filePanelClass)?.setAttribute('style', height);
      }
    }
  }

  /**
   * Set Report Tab Height
   */
  reportTabHeightCalculation() {
    const windowHeight = window.innerHeight;
    const tabPanel = document.querySelector(this.tabContainer);
    const titlePanel = document.querySelector(this.authoringHeader);
    const protipPanel = document.querySelector(this.taxonomyProtip);
    const tabHeight = tabPanel ? tabPanel.clientHeight : 0;
    const titleHeight = titlePanel ? titlePanel.clientHeight : 0;
    const protipHeight = protipPanel ? protipPanel.clientHeight : 0;
    const extraHeight = 56 + 57;
    const panelHeight =
      windowHeight - (tabHeight + titleHeight + protipHeight + extraHeight);
    const leftPanel = document.querySelector('.report-left');
    const rightPanel = document.querySelector('.report-right');
    if (leftPanel) {
      const height = 'height:' + (panelHeight + 57) + 'px';
      leftPanel?.setAttribute('style', height);
    }
    if (rightPanel) {
      const height = 'height:' + panelHeight + 'px';
      rightPanel?.setAttribute('style', height);
    }
  }

  /**
   * Set Jasper Report tab Height
   */
  jasperReportHeightCal() {
    const windowHeight = window.innerHeight;
    const headerPanel = document.querySelector(this.authoringHeader);
    const headerHeight = headerPanel ? headerPanel.clientHeight : 0;
    const panelHeight = windowHeight - (headerHeight + 99);
    const leftPanel = document.querySelector('.report-left');
    const rightPanel = document.querySelector('.report-right');
    if (leftPanel) {
      const height = 'height:' + (panelHeight + 68) + 'px';
      leftPanel?.setAttribute('style', height);
    }
    if (rightPanel) {
      const height = 'height:' + (panelHeight + 12) + 'px';
      rightPanel?.setAttribute('style', height);
    }
  }


  /**
   * Set Custom Taxonomy Height
   */
  customTaxonomyHeightCal() {
    const windowHeight = window.outerHeight;

    const headerHeight =
      document.getElementsByClassName('authoring-header')[0]?.clientHeight;

    const rightPanelDetailHeaderHeight =
      document.getElementsByClassName('association-details-header').length ?
        document.getElementsByClassName('association-details-header')[0]?.clientHeight
        : 0;


    const rightPanelDetailFilterHeight =
      document.getElementsByClassName('association-details-filter').length ?
        document.getElementsByClassName('association-details-filter')[0]?.clientHeight
        : 0;

    const rightPanelDetailContentHeight =
      windowHeight - (headerHeight + rightPanelDetailHeaderHeight + rightPanelDetailFilterHeight);
    const extraHeight = 0;

    const panelHeight = windowHeight - (headerHeight + extraHeight);
    const customViewPanel = document.querySelector('.custom-view');

    const height = 'height:' + panelHeight + 'px';
    customViewPanel?.setAttribute('style', height);
    const customViewAssociatonDetailPanel =
      customViewPanel?.querySelector('.association-details-content');

    const customViewheight = 'height:' + (rightPanelDetailContentHeight - 20) + 'px';
    customViewAssociatonDetailPanel?.setAttribute('style', customViewheight);
  }

  /**
   * Date Range Calender Open Clicks
   */
  onDateRangeCalendarOpenClick() {
    document.querySelector('btnpicker')?.addEventListener('click', (event: any) => {
      if (document.querySelector('.mydrp .selector .titleareatxt')) {
        document.querySelector('.mydrp .selector .titleareatxt').setAttribute('aria-live', 'assertive');
      }
      if (document.querySelector('.mydrp .selector .headerclearbtn')) {
        document.querySelector('.mydrp .selector .headerclearbtn').setAttribute('aria-label', 'Clear date range');
      }
      if (document.querySelector('.mydrp .selector .headerokbtn')) {
        document.querySelector('.mydrp .selector .headerokbtn').setAttribute('aria-label', 'Finish date range');
      }
    });
  }

  /**
   * Set FrontFace Taxonomy Details height
   */
  frontFacetaxonomyDetailsHeightCal() {
    const windowHeight = window.outerHeight;
    const headerHeight = document.getElementsByClassName('ff-header')[0]?.clientHeight;
    const contentExtraHeight = window.document.body.offsetHeight;
    const protipHeight =
      document.querySelector(this.taxonomyProtip)?.clientHeight ?
        document.querySelector(this.taxonomyProtip)?.clientHeight
        : 0;
    const extraHeight = 0;
    const panelHeight =
      windowHeight - (headerHeight + contentExtraHeight + protipHeight + extraHeight);
    const treeContainerHeight = 'height:' + (panelHeight - 20) + 'px';
    document.getElementById('tree_container_id')?.setAttribute('style', treeContainerHeight);
    const rightContainerHeight = 'height:' + (panelHeight - 16) + 'px';
    document.getElementById('right_container_id')?.setAttribute('style', rightContainerHeight);
  }

  /**
   * Set Public Review Height
   */
  publicReviewHeightCalculation() {
    const windowHeight = window.innerHeight;
    const titleHeight = document.querySelector(this.authoringHeader)?.clientHeight;
    const protipHeight =
      document.querySelector('.review-comment .review-protip')?.clientHeight ?
        document.querySelector('.review-comment .review-protip')?.clientHeight
        : 0;
    const extraHeight = 0;
    const navBarHeight = document.querySelector('#navBar')?.clientHeight;
    const panelHeight =
      windowHeight - (titleHeight + protipHeight + extraHeight + navBarHeight);
    const commentTreeHeight = 'height:' + panelHeight + 'px';
    document.getElementById('comment_container_id')?.setAttribute('style', commentTreeHeight);
    const rightContainerId = 'height:' + (panelHeight - 17) + 'px';
    document.getElementById('right_container_id')?.setAttribute('style', rightContainerId);
    document.getElementById('publicReviewTree')?.setAttribute('style', commentTreeHeight);
  }

  /**
   * Set pacing guide details height
   */
  pacingGuideDetailsHeightCalculation() {
    const windowHeight = window.innerHeight;
    const tabHeight =
      document.querySelector('#treeTabContainer')?.clientHeight
      + document.querySelector(this.tabContainer)?.clientHeight;
    const titleHeight = document.querySelector(this.authoringHeader)?.clientHeight;
    const protipHeight =
      document.querySelector(this.taxonomyProtip)?.clientHeight ?
        document.querySelector(this.taxonomyProtip)?.clientHeight
        : 0;
    const extraHeight = 60;
    const navBarHeight = document.querySelector('#navBar')?.clientHeight;
    const panelHeight =
      windowHeight - (tabHeight + titleHeight + protipHeight + extraHeight + navBarHeight);
    const treeViewHeight = 'height:' + panelHeight + 'px';
    document.querySelector(this.treeDetailsView)?.setAttribute('style', treeViewHeight);
    const rightContainerId = 'height:' + (panelHeight - 16) + 'px';
    document.querySelector(this.rightContainerId)?.setAttribute('style', rightContainerId);
  }

  /**
   * Set search height
   */
  searchHeightCalculation(onresize?) {
    const windowHeight = window.innerHeight;
    const titleHeight =
      document.querySelector(this.authoringHeader)?.clientHeight;
    const navBarHeight =
      document.querySelector('#navBar')?.clientHeight;
    const tabPHgt = document.querySelector('#tabPanel')?.clientHeight;
    const tabContHeight = document.querySelector('.tab-container')?.clientHeight;
    const panelHeight = windowHeight - (
      titleHeight + 40 + navBarHeight + tabPHgt + tabContHeight
    );
    const srchRsltHeight = 'height:' + panelHeight + 'px';

    document.querySelector('.panel-left')?.setAttribute(
      'style',
      srchRsltHeight
    );
    document.querySelector('.panel-right')?.setAttribute('style', srchRsltHeight);
    if(!onresize && this.router.url.indexOf('taxonomy/detail') !== -1){
      document.querySelector('.taxonomyDataContainer')?.setAttribute(
        'style',
        srchRsltHeight
      );
    }
    if(this.router.url.indexOf('taxonomy/detail') !== -1 ){
      document.querySelector('.taxonomyDataContainer').scrollTop =0;
    }else if(this.router.url.indexOf('project/authoring') !== -1){
      document.querySelector('#modal-body-taxonomyAssociation').scrollTop =0;
    }
  }

  /**
   * Set pacing guide height
   */
  pacingGuideHeightCalculation() {
    const modalBody =
      document.querySelector('#createPacingGuide .modal-body');
    const modalBodyHeight =
      document.querySelector(this.modalBodyClass)?.clientHeight;
    const bodyContentHeight =
      document.querySelector('#createPacingGuide .modal-body #pgModalContent');
    let totalHeight = 0;
    const modalBodyChildren = modalBody?.querySelector('.taxonomy-selection-list')?.children;
    for (let i = 0; i < modalBodyChildren?.length ; i++) {
      totalHeight = totalHeight + modalBodyChildren[i].clientHeight;
    }
    if (totalHeight > modalBodyHeight) {
      const contentBodyHeigth = 'height:' + totalHeight + 'px';
      bodyContentHeight.setAttribute('style', contentBodyHeigth);
    } else {
      const contentBodyHeigth = 'height:' + modalBodyHeight + 'px';
      bodyContentHeight?.setAttribute('style', contentBodyHeigth);
    }
  }

  /**
   * Detect IE comptability
   */
  detectIECompatible() {
    const ua = window.navigator.userAgent;
    let version = 0;
    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return false
      version = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      return false;
    }
    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return false
      const rv = ua.indexOf('rv:');
      version = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      return false;
    }
    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return true
      version = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      return true;
    }
    // other browser
    return true;
  }

  /**
   * Show the IE browser comptability message
   */
  showIEBrowserIncompatibleMsg() {
    if (this.detectIECompatible() === false) { // not compatible
      // Show alert
      document.querySelector(this.incomMsgEL).classList.remove('hideIEmsg');
      document.querySelector(this.incomMsgEL).classList.add('showIEmsg');
    } else { // compatible
      // hide alert
      document.querySelector(this.incomMsgEL).classList.remove('showIEmsg');
      document.querySelector(this.incomMsgEL).classList.add('hideIEmsg');
    }
    // on ok button click, hide alert
    const button = document.querySelector('#IEdialogTitleDiv').querySelector('#alertButtonDiv').querySelector('#IEAlertOk');
    button.addEventListener('click', (event: any) => {
      document.querySelector(this.incomMsgEL).classList.remove('showIEmsg');
      document.querySelector(this.incomMsgEL).classList.add('hideIEmsg');
    });
  }

  /**
   * Add focus on the email input box
   */
  focusOnEmailInputBox() {
    document.getElementById('emailID').focus();
  }

  /**
   * Add focus on the cancel button
   */
  focusOnCancelBtn(className) {
    document.querySelector(className)?.focus();
  }

  /**
   * Add focus on the modal close button
   */
  focusOnModalCloseBtn() {
    document.getElementsByTagName('app-modal')[0].setAttribute('aria-hidden', 'true');
    setTimeout(() => {
      const id = document.querySelector('.modal-content .js-close-btn').id;
      document.getElementById(id).focus();
      document.getElementsByTagName('app-modal')[0].removeAttribute('aria-hidden');
      document.getElementById(id).focus();
    }, 500);
  }

  /**
   * Preventing the default behaviour of the browser
   */
  preventBehavior(e) {
    e.preventDefault();
  }

    /**
     * Check the current location and return the location in the enumeration
     *
     * @returns the location for the current page in terms of enum
     */
    checkRouteLocation() {
      if (this.router.url.indexOf('app') === -1)
      {
        return Utils.FRONT_FACING_ENUM;
      }
    }

    /**
     * Get the unauthorized apis parameters
     *
     * @returns query parameters
     */
    getUnauthApiParams() {
      const currentLocation = this.checkRouteLocation();
      const orgId = JSON.parse(localStorage.getItem('orgDetails'))?.orgId;
      const queryParam = (currentLocation === Utils.FRONT_FACING_ENUM)
          ? 'front_facing=true&organization_id=' + orgId
          : '';
      return queryParam;
    }

    // get org code
    getOrgCode() {
        if (localStorage.getItem('orgDetails'))
        {
            return (Utils.prefix + JSON.parse(localStorage.getItem('orgDetails')).orgCode);
        }
    }

  /**
   * Calculate and set listing page search height
   * 
   * @return void
   */
  searchHeightCalculationList(){
    const windowHeight = window.innerHeight;
    const headerHieght = document.querySelector('#topNav')?.clientHeight;
    const panelHeight = windowHeight - headerHieght;
    const searchResultHeight = 'height:' + panelHeight + 'px';
    const querySelectorAttr = (this.router.url.indexOf('project/detail') !== -1)
      ? '.projectDataContainer'
      : '#touchsurface';
    document.querySelector(querySelectorAttr)?.setAttribute(
      'style',
      searchResultHeight
    );
    document.querySelector(querySelectorAttr).scrollTop =0;
  }

  /**
   * Functionality to calcualate height on container start
   * 
   * @return void
   */
  calculateContainerHeight() {
    const windowHeight = window.innerHeight;
    let navHeight;
    if (document.getElementById('topNav')) {
      navHeight = document.getElementById('topNav').offsetHeight;
    }
    const containerHeight = windowHeight - navHeight;
    if (document.getElementById('touchsurface')) {
      document.getElementById('touchsurface').style.height = containerHeight + 'px';
      document.getElementById('touchsurface').scrollTop = 0;
    }
  }

}
